/**
 * @fileoverview PUT handler for the "/companies/:company_id/contact_information" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { contactInformationCacheKey, settingsCacheKey } from "./constants";
import type { CompanyContactInformationPayload, PutCompanyContactInformationProps } from "./types";

export const putCompanyContactInformation = reactQueryMutationAdapter(
  [contactInformationCacheKey, settingsCacheKey],
  (props: PutCompanyContactInformationProps): Promise<CompanyContactInformationPayload> => {
    return fetch(`/companies/${props.company_id}/contact_information`, "PUT", props);
  }
);
